<template>

<div>
  <div class="row">
    <div class="form-group col-lg-6">
      <label for="serial">{{ $t('serial') }}</label>
      <input
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_serial')"
        v-model="serial"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      >
    </div>
  </div>

  <LoaderButton
    @click="getLastPositions"
  >
    {{ $t('search') }}
  </LoaderButton>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white light-bottom-shadow"
        :items="lastPositions"
        :fields='fieldsLastPositions'
      />
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment-timezone'
import { request } from '@/lib/http'

export default {
  name: 'ReportLastPosition',
  components: {
    LoaderButton
  },
  data () {
    return {
      serial: '',
      board: '',
      fieldsLastPositions: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'ignition',
          label: this.$t('ignition'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'speed',
          label: this.$t('speed')
        },
        {
          key: 'odometer',
          label: this.$t('odometer')
        },
        {
          key: 'gprs',
          label: 'GPRS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'gps',
          label: 'GPS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'panic',
          label: this.$t('panic'),
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'out1',
          label: this.$t('outs_1/2'),
          formatter: (value, key, item) => {
            const out1 = value ? 'SIM' : 'NÃO'
            const out2 = item.out2 ? 'SIM' : 'NÃO'

            return out1 + '/' + out2
          }
        },
        {
          key: 'voltage',
          label: this.$t('voltage'),
          formatter: (value, key, item) => {
            return value + 'V'
          }
        },
        {
          key: 'temperature1',
          label: 'T1',
        },
        {
          key: 'latitude',
          label: this.$t('lat/lon'),
          formatter: (value, key, item) => {
            return value
              ? value + '/' + item.longitude
              : ''
          }
        },
        {
          key: 'in1',
          label: this.$t('in_1/2/3'),
          formatter: (value, key, item) => {
            const in1 = value ? 'SIM' : 'NÃO'
            const in2 = item.in2 ? 'SIM' : 'NÃO'
            const in3 = item.in3 ? 'SIM' : 'NÃO'

            return in1 + '/' + in2 + '/' + in3
          }
        }
      ],
      lastPositions: []
    }
  },

  watch: {
    board: function(value) {
      // Define máscara da placa
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (value.length === 3){
        this.board = value + '-'
      }

      if (value.length === 4 && !value.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    }
  },

  methods: {
    async getLastPositions() {
      const { dispatch } = this.$store

      if (!this.serial && !this.board) {
        return dispatch('notify/error', { message: 'É necessário informar o serial ou placa do veículo' })
      }

      dispatch('overlay/show', true)

      let params = {}
      if (this.serial) {
        params.serial = this.serial
      }
      if (this.board) {
        params.board = this.board
      }

      const { rows } = await request({
        url   : 'vehicledata',
        method: 'get',
        params
      })

      if (rows.length === 0) {
        this.lastPositions = []

        dispatch('overlay/show', false)

        return dispatch('notify/error', { message: 'Veículo não encontrado!' })
      }

      try {
        const positions = await request({
          url   : 'last-positions',
          method: 'get',
          params: { vehicleId: rows[0].VEI_ID }
        })

        this.lastPositions = positions
      } catch (error) {}

      dispatch('overlay/show', false)
    }
  },
}
</script>
